<div class="dialog-sm -m-6 flex flex-col">
  <div class="flex h-16 flex-0 items-center justify-between bg-primary px-4">
    <div class="flex items-center gap-2 text-white">
      <mat-icon fontIcon="lock"></mat-icon>
      <span class="text-lg font-semibold">Subscription Payment Reminder</span>
    </div>
  </div>

  <div class="overflow-y-auto p-4">
    <div class="mb-2 flex items-center justify-center">
      <mat-icon class="p-6 !text-6xl text-red-400" fontIcon="block"></mat-icon>
    </div>

    @if (data.disableComment) {
      <p class="mb-4 text-center text-gray-700">{{ data.disableComment }}</p>
    } @else {
      <p class="mb-4 text-center text-gray-700">Your subscription payment is overdue</p>
    }

    @if (countDown > 0) {
      <div class="mt-4 flex items-center justify-center gap-2 rounded-md bg-gray-100 py-3">
        <mat-icon class="text-gray-500" fontIcon="timer"></mat-icon>
        <span class="text-sm text-gray-500">
          Access will resume in <strong class="text-gray-800">{{ countDown }}</strong> seconds
        </span>
      </div>
    }
    <div class="mt-4 flex justify-center">
      <button mat-flat-button color="primary" class="m-1 items-center" (click)="logout()" [disabled]="loading > 0">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span class="ms-2">Sign out</span>
      </button>
    </div>
  </div>
</div>
